import * as React from 'react';
import styles from './index.less';
import { Affix, Checkbox, Modal, Space } from 'antd';
import FSwitch from '@/components/FSwitch';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, NodeManagerModelState } from '@/models/connect';
import { history } from '@@/core/history';
import {
  ChangeAction,
  FetchExhibitsAction,
  OnChange_Exhibit_InputFilter_Action,
  OnChange_Exhibit_SelectedStatus_Action,
  OnChange_Exhibit_SelectedType_Action,
  OnLoadMore_ExhibitList_Action,
  OnMount_ExhibitPage_Action,
  OnOnlineOrOfflineAction,
  OnUnmount_ExhibitPage_Action,
} from '@/models/nodeManagerPage';
import { ChangeAction as DiscoverChangeAction } from '@/models/discoverPage';
import FNoDataTip from '@/components/FNoDataTip';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FLoadingTip from '@/components/FLoadingTip';
// import FLeftSiderLayout from '@/layouts/FLeftSiderLayout';
// import Sider from '@/pages/node/formal/$id/Sider';
import FTooltip from '@/components/FTooltip';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FListFooter from '@/components/FListFooter';
import FCoverImage from '@/components/FCoverImage';
import { Helmet } from 'react-helmet';
import FComponentsLib from '@freelog/components-lib';
// import FResourceTypeFilter from '@/components/FResourceTypeFilter';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import fCenterMessage from '@/components/fCenterMessage';
// import fPolicyBuilder from '@/components/fPolicyBuilder';
import { fOnOffFeedback } from '@/components/fOnOffFeedback';
import fMessage from '@/components/fMessage';
// import FModal from '@/components/FModal';
// import FSingleLineInput from '@/components/FSingleLineInput';
import FResourceTypeInput4 from '@/components/FResourceTypeInput4';
import FIcons from '@/components/FIcons';
import FDropdown2 from '@/components/FDropdown2';
import FResourceTypeFilter3 from '@/components/FResourceTypeFilter3';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';
import FInput_Search from '@/components/FInput_Search';
import fPolicyBuilder3 from '@/components/fPolicyBuilder3';

interface ExhibitsProps {
  dispatch: Dispatch;
  nodeManagerPage: NodeManagerModelState;
}

function Exhibits({ dispatch, nodeManagerPage }: ExhibitsProps) {
  const [$affixed, set$affixed, get$affixed] = FUtil.Hook.useGetState<boolean>(false);
  const scroll = AHooks.useScroll(self.document.getElementById('right-content'));
  // console.log(scroll, 'scroll iosdjf;lksdjl;fkjlk;jlk');
  AHooks.useMount(() => {
    dispatch<OnMount_ExhibitPage_Action>({
      type: 'nodeManagerPage/onMount_ExhibitPage',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_ExhibitPage_Action>({
      type: 'nodeManagerPage/onUnmount_ExhibitPage',
    });
  });

  const { run } = AHooks.useDebounceFn(
    () => {
      dispatch<FetchExhibitsAction>({
        type: 'nodeManagerPage/fetchExhibits',
        payload: {
          restart: true,
        },
      });
    },
    {
      wait: 300,
    },
  );

  return (
    <>
      <Helmet>
        <title>{`展品管理 · ${nodeManagerPage.nodeTitle || nodeManagerPage.nodeName} - Freelog`}</title>
      </Helmet>
      {/* <FLeftSiderLayout
        type={nodeManagerPage.exhibit_ListState === 'noData' ? 'empty' : 'table'}
        sider={<Sider />}
        contentStyles={{
          backgroundColor: '#fafbfc',
          boxShadow: 'none',
        }}
      > */}
      {nodeManagerPage.exhibit_ListState === 'noData' && (
        <div
          style={{
            height: 'calc(100vh - 70px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100%',
            backgroundColor: '#fafbfc',
          }}
        >
          <div className={styles.emptyPrompt}>
            <div
              style={{
                fontSize: 30,
                lineHeight: '36px',
                color: '#666',
                textAlign: 'center',
              }}
            >
              {FI18n.i18nNext.tAuto('manage_exhibits_empty')}
            </div>

            <FComponentsLib.FRectBtn
              size='large'
              className={styles.btn}
              onClick={() => {
                dispatch<DiscoverChangeAction>({
                  type: 'discoverPage/change',
                  payload: {
                    resourceType: '-1',
                  },
                });
                history.push(FUtil.LinkTo.market());
              }}
            >
              {FI18n.i18nNext.tAuto('btn_go_to_resource_market')}
            </FComponentsLib.FRectBtn>

            <div style={{ height: 50 }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <FComponentsLib.FTipText
                type={'third'}
                text={
                  // 也可以先创建合集，再添加展品
                  FI18n.i18nNext.t('manage_exhibits_empty_msg2')
                }
              />
              <FComponentsLib.FTextBtn
                type={'primary'}
                onClick={() => {
                  self.open(`/node/collectionExhibitCreator/${nodeManagerPage.nodeId}`);
                }}
              >
                {
                  // 创建合集
                  FI18n.i18nNext.tAuto('manage_exhibits_empty_btn2')
                }
              </FComponentsLib.FTextBtn>
            </div>
          </div>
        </div>
      )}

      <div style={{ width: '100%', backgroundColor: '#fafbfc', boxShadow: 'none' }}>
        {nodeManagerPage.exhibit_ListState !== 'noData' && (
          <div className={styles.header} style={{ padding: '0 20px', backgroundColor: '#fafbfc' }}>
            <FComponentsLib.FTitleText
              type='h1'
              text={
                // 展品管理
                FI18n.i18nNext.tAuto('nodemgnt_manageexhibis_title') +
                ' ' +
                (nodeManagerPage.exhibit_ListTotal === -1
                  ? ''
                  : `(${nodeManagerPage.exhibit_ListTotal})`)
              }
            />
            <Space size={50}>
              <FComponentsLib.FTextBtn
                style={{ fontSize: 14 }}
                onClick={() => {
                  self.open(`/node/collectionExhibitCreator/${nodeManagerPage.nodeId}`);
                }}
              >
                <FIcons.FResource style={{ fontSize: 14, color: 'inherit' }} />
                &nbsp;
                {
                  // 创建合集
                  FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_btn_createcollection')
                }
              </FComponentsLib.FTextBtn>

              {!nodeManagerPage.isBatchManagement && (
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 14 }}
                  onClick={() => {
                    dispatch<ChangeAction>({
                      type: 'nodeManagerPage/change',
                      payload: {
                        isBatchManagement: true,
                      },
                    });
                  }}
                >
                  <FIcons.FConfiguration style={{ fontSize: 14 }} />
                  &nbsp;{FI18n.i18nNext.tAuto('myresources_btn_bulkaction')}
                </FComponentsLib.FTextBtn>
              )}

              <div>
                <span>
                  {
                    // 资源类型
                    FI18n.i18nNext.tAuto('resource_type')
                  }
                  ：
                </span>

                <FResourceTypeFilter3
                  subjectTypeArr={['resource', 'collection', 'exhibitCollection']}
                  value={nodeManagerPage.exhibit_ResourceTypeCodes}
                  omitTheme={true}
                  onChange={(value) => {
                    dispatch<OnChange_Exhibit_SelectedType_Action>({
                      type: 'nodeManagerPage/onChange_Exhibit_SelectedType',
                      payload: {
                        value: value,
                      },
                    });
                  }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                }}
              >
                <span>
                  {
                    // 状态
                    FI18n.i18nNext.tAuto('filte_exhibit_state')
                  }
                  ：
                </span>
                <FDropdown2
                  autoArrow={true}
                  menu={{
                    selectedKeys: [nodeManagerPage.exhibit_SelectedStatus],
                    items: nodeManagerPage.exhibit_ResourceStateOptions.map((rs) => {
                      return {
                        key: rs.value,
                        label: rs.text,
                      };
                    }),
                    onClick: (value) => {
                      dispatch<OnChange_Exhibit_SelectedStatus_Action>({
                        type: 'nodeManagerPage/onChange_Exhibit_SelectedStatus',
                        payload: {
                          value: value.key,
                        },
                      });
                    },
                  }}
                >
                  <span>
                    {
                      nodeManagerPage.exhibit_ResourceStateOptions.find((rso) => {
                        return rso.value === nodeManagerPage.exhibit_SelectedStatus.toString();
                      })?.text
                    }
                  </span>
                </FDropdown2>
              </div>

              <div>
                {/* <FComponentsLib.FInput.FSearch */}
                <FInput_Search
                  value={nodeManagerPage.exhibit_InputFilter}
                  onChange={(e) => {
                    dispatch<OnChange_Exhibit_InputFilter_Action>({
                      type: 'nodeManagerPage/onChange_Exhibit_InputFilter',
                      payload: {
                        value: e.target.value,
                      },
                    });
                    run();
                  }}
                  className={styles.input}
                  placeholder={FI18n.i18nNext.t('nodemngt_exhibit_search_hint')}
                />
              </div>
            </Space>
          </div>
        )}

        {nodeManagerPage.exhibit_ListState === 'loading' && (
          <FLoadingTip height={'calc(100vh - 270px)'} />
        )}

        {nodeManagerPage.exhibit_ListState === 'noSearchResult' && (
          <FNoDataTip height={'calc(100vh - 270px)'} tipText={'无搜索结果'} />
        )}

        {nodeManagerPage.exhibit_ListState === 'loaded' && (
          <>
            {nodeManagerPage.isBatchManagement && (
              <>
                <Affix
                  offsetTop={0}
                  target={() => {
                    return self.document.querySelector(
                      '#right-content .simplebar-content-wrapper',
                    ) as HTMLElement;
                  }}
                  onChange={(affixed) => {
                    set$affixed(affixed ?? false);
                  }}
                >
                  <div
                    className={styles.handled}
                    style={
                      $affixed
                        ? {
                          backgroundColor: 'white',
                          marginLeft: -20,
                          marginRight: -20,
                          paddingLeft: 40,
                          paddingRight: 40,
                          justifyContent: 'space-between',
                          height: 70,
                        }
                        : {}
                    }
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 30,
                      }}
                    >
                      {(scroll?.top || 0) > 170 && (
                        <Space size={5} style={{ flexShrink: -1, flexBasis: 100 }}>
                          <Checkbox
                            checked={
                              nodeManagerPage.checkedExhibitIDs.length ===
                              nodeManagerPage.exhibit_List.length
                            }
                            indeterminate={
                              nodeManagerPage.checkedExhibitIDs.length !== 0 &&
                              nodeManagerPage.checkedExhibitIDs.length !==
                              nodeManagerPage.exhibit_List.length
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                dispatch<ChangeAction>({
                                  type: 'nodeManagerPage/change',
                                  payload: {
                                    checkedExhibitIDs: nodeManagerPage.exhibit_List.map((o) => {
                                      return o.id;
                                    }),
                                  },
                                });
                              } else {
                                dispatch<ChangeAction>({
                                  type: 'nodeManagerPage/change',
                                  payload: {
                                    checkedExhibitIDs: [],
                                  },
                                });
                              }
                            }}
                          />
                          <FComponentsLib.FTitleText
                            style={{ display: 'inline-block' }}
                            type='table'
                            text={'全选'}
                          />
                        </Space>
                      )}

                      <FComponentsLib.FContentText
                        type={'additional2'}
                        style={{ fontSize: 14, flexShrink: 0 }}
                        text={FI18n.i18nNext.t(
                          'nodemgnt_exhibitmgnt_bulkaction_label_selectedqty',
                          {
                            Qty: nodeManagerPage.checkedExhibitIDs.length,
                          },
                        )}
                      />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 30,
                      }}
                    >
                      <FComponentsLib.FTextBtn
                        disabled={nodeManagerPage.checkedExhibitIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          if (nodeManagerPage.checkedExhibitIDs.length === 0) {
                            return fCenterMessage({
                              message: '请选择要执行操作的对象',
                            });
                          }

                          const {
                            ret,
                            errCode,
                            msg,
                            data,
                          }: {
                            ret: number;
                            errCode: number;
                            msg: string;
                            data: {
                              [resourceID: string]: {
                                data: any;
                                status: 1 | 2;
                              };
                            };
                          } = await FServiceAPI.Exhibit.batchUpdatePresentableStatus({
                            presentableIds: nodeManagerPage.checkedExhibitIDs,
                            onlineStatus: 1,
                          });

                          if (ret !== 0 || errCode !== 0) {
                            return fCenterMessage({ message: msg });
                          }

                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              exhibit_List: nodeManagerPage.exhibit_List.map((rl) => {
                                // console.log(data[rl.id], 'data[rl.id] sdifjsd;lkfjlksdjflkjlsdkj');
                                if (data[rl.id] && data[rl.id].status === 1) {
                                  return {
                                    ...rl,
                                    isOnline: true,
                                  };
                                }
                                return rl;
                              }),
                            },
                          });

                          if (
                            Object.values(data).every((d) => {
                              return d.status === 1;
                            })
                          ) {
                            fOnOffFeedback({
                              state: 'on',
                              message: '上架成功',
                            });
                            return;
                          }
                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              updateExhibitResultType: 'online',
                              updateExhibitResult: data,
                            },
                          });
                        }}
                      >
                        <FIcons.FUpcast style={{ fontSize: 14 }} />
                        &nbsp;
                        {FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_bulkaction_btn_availabletoauth')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={nodeManagerPage.checkedExhibitIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          if (nodeManagerPage.checkedExhibitIDs.length === 0) {
                            return fCenterMessage({
                              message: '请选择要执行操作的对象',
                            });
                          }
                          const confirm: boolean = await fPromiseModalConfirm({
                            title: '',
                            description: FI18n.i18nNext.t('confirm_msg_remove_exhibits_from_auth'),
                            okText: FI18n.i18nNext.t('btn_remove_exhibits_from_auth'),
                            promptKey_localStorage: 'offlineExhibit',
                          });
                          if (!confirm) {
                            return;
                          }

                          const {
                            ret,
                            errCode,
                            msg,
                            data,
                          }: {
                            ret: number;
                            errCode: number;
                            msg: string;
                            data: {
                              [resourceID: string]: {
                                data: any;
                                status: 1 | 2;
                              };
                            };
                          } = await FServiceAPI.Exhibit.batchUpdatePresentableStatus({
                            presentableIds: nodeManagerPage.checkedExhibitIDs,
                            onlineStatus: 0,
                          });

                          if (ret !== 0 || errCode !== 0) {
                            return fCenterMessage({ message: msg });
                          }

                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              exhibit_List: nodeManagerPage.exhibit_List.map((rl) => {
                                if (data[rl.id] && data[rl.id].status === 1) {
                                  return {
                                    ...rl,
                                    isOnline: false,
                                  };
                                }
                                return rl;
                              }),
                            },
                          });

                          if (
                            Object.values(data).every((d) => {
                              return d.status === 1;
                            })
                          ) {
                            fOnOffFeedback({
                              state: 'off',
                              message: '下架成功',
                            });
                            return;
                          }

                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              updateExhibitResultType: 'offline',
                              updateExhibitResult: data,
                            },
                          });
                        }}
                      >
                        <FIcons.FUpcast style={{ fontSize: 14, transform: 'rotate(180deg)' }} />
                        &nbsp;
                        {FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_bulkaction_btn_remoefromauth')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        disabled={nodeManagerPage.checkedExhibitIDs.length === 0}
                        type={'primary'}
                        onClick={async () => {
                          if (nodeManagerPage.checkedExhibitIDs.length === 0) {
                            return fCenterMessage({
                              message: '请选择要执行操作的对象',
                            });
                          }
                          const result = await fPolicyBuilder3({
                            // targetType: 'resource',
                            resourceTypeCode: nodeManagerPage.exhibit_List.map((rl) => {
                              return rl.resourceTypeCode;
                            }),
                            nodeID: nodeManagerPage.nodeId,
                          });
                          if (!result) {
                            return;
                          }

                          const {
                            ret,
                            errCode,
                            msg,
                            data,
                          }: {
                            ret: number;
                            errCode: number;
                            msg: string;
                            data: {
                              [resourceID: string]: {
                                data: any;
                                status: 1 | 2;
                              };
                            };
                          } = await FServiceAPI.Exhibit.batchUpdatePresentable({
                            presentableIds: nodeManagerPage.checkedExhibitIDs,
                            addPolicies: [
                              {
                                policyName: result.title,
                                policyText: result.text,
                                status: 1,
                              },
                            ],
                          });

                          if (ret !== 0 || errCode !== 0) {
                            return fCenterMessage({ message: msg });
                          }

                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              exhibit_List: nodeManagerPage.exhibit_List.map((rl) => {
                                // console.log(data[rl.id], 'data[rl.id] sdifjsd;lkfjlksdjflkjlsdkj');
                                if (data[rl.id] && data[rl.id].status === 1) {
                                  return {
                                    ...rl,
                                    policies: [...rl.policies, result.title],
                                    hasPolicy: true,
                                  };
                                }
                                return rl;
                              }),
                            },
                          });

                          if (
                            Object.values(data).every((d) => {
                              return d.status === 1;
                            })
                          ) {
                            fCenterMessage({ message: '策略添加成功' });
                            return;
                          }

                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              updateExhibitResultType: 'addPolicy',
                              updateExhibitResult: data,
                            },
                          });
                        }}
                      >
                        <FIcons.FPolicy style={{ fontSize: 14 }} />
                        &nbsp;
                        {FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_bulkaction_btn_addauthplan')}
                      </FComponentsLib.FTextBtn>

                      <FComponentsLib.FTextBtn
                        type={'danger'}
                        onClick={() => {
                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              isBatchManagement: false,
                              checkedExhibitIDs: [],
                            },
                          });
                        }}
                      >
                        <FIcons.FExit style={{ fontSize: 14 }} />
                        &nbsp;
                        {FI18n.i18nNext.tAuto('myresources_bulkaction_btn_quit')}
                      </FComponentsLib.FTextBtn>
                    </div>
                  </div>
                </Affix>
                <div style={{ height: 30 }} />
              </>
            )}
            <div className={styles.body}>
              <div className={styles.listTile}>
                {nodeManagerPage.isBatchManagement && (
                  <Space size={5} style={{ flexShrink: -1, flexBasis: 100 }}>
                    <Checkbox
                      checked={
                        nodeManagerPage.checkedExhibitIDs.length ===
                        nodeManagerPage.exhibit_List.length
                      }
                      indeterminate={
                        nodeManagerPage.checkedExhibitIDs.length !== 0 &&
                        nodeManagerPage.checkedExhibitIDs.length !==
                        nodeManagerPage.exhibit_List.length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              checkedExhibitIDs: nodeManagerPage.exhibit_List.map((o) => {
                                return o.id;
                              }),
                            },
                          });
                        } else {
                          dispatch<ChangeAction>({
                            type: 'nodeManagerPage/change',
                            payload: {
                              checkedExhibitIDs: [],
                            },
                          });
                        }
                      }}
                    />
                    <FComponentsLib.FTitleText
                      style={{ display: 'inline-block' }}
                      type='table'
                      text={'全选'}
                    />
                  </Space>
                )}

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexBasis: '100%',
                    flexShrink: 100,
                  }}
                >
                  <FComponentsLib.FContentText
                    text={
                      // 展品
                      FI18n.i18nNext.t('tableheader_exhibit')
                    }
                    type={'normal'}
                  />
                  <FComponentsLib.FContentText
                    text={
                      // 上线
                      FI18n.i18nNext.t('tableheader_show_exhibit')
                    }
                    type={'normal'}
                  />
                </div>
              </div>

              {nodeManagerPage.exhibit_List.map((el) => {
                return (
                  <div className={styles.listItem} key={el.id}>
                    {nodeManagerPage.isBatchManagement && (
                      <div style={{ flexShrink: 0, flexBasis: 100 }}>
                        <Checkbox
                          checked={nodeManagerPage.checkedExhibitIDs.includes(el.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              dispatch<ChangeAction>({
                                type: 'nodeManagerPage/change',
                                payload: {
                                  checkedExhibitIDs: [...nodeManagerPage.checkedExhibitIDs, el.id],
                                },
                              });
                            } else {
                              dispatch<ChangeAction>({
                                type: 'nodeManagerPage/change',
                                payload: {
                                  checkedExhibitIDs: nodeManagerPage.checkedExhibitIDs.filter(
                                    (id) => {
                                      return id !== el.id;
                                    },
                                  ),
                                },
                              });
                            }
                          }}
                        />
                      </div>
                    )}

                    <div
                      style={{
                        flexBasis: '100%',
                        flexShrink: 1,
                        overflow: 'hidden',
                      }}
                    >
                      <div className={styles.listItemInfo} style={{ width: '100%' }}>
                        <div style={{ display: 'flex', flexShrink: 100 }}>
                          <div style={{ flexBasis: 104, flexShrink: -1 }}>
                            <FCoverImage
                              src={el.cover || ''}
                              width={104}
                              style={{ borderRadius: 4 }}
                            />
                          </div>
                          <div style={{ width: 10, flexShrink: -1 }} />
                          <div
                            className={styles.infos}
                            style={{ flexShrink: 100, flexBasis: '100%' }}
                          >
                            <FComponentsLib.FContentText
                              singleRow
                              text={el.title}
                              style={{ maxWidth: 1000 }}
                            />
                            <Space size={4}>
                              <FComponentsLib.FContentText
                                singleRow
                                type={'additional2'}
                                text={el.resourceName}
                                style={{
                                  color: '#666',
                                }}
                              />
                              <FComponentsLib.FContentText
                                type={'additional2'}
                                text={'|'}
                                style={{ color: '#666' }}
                              />
                              <FComponentsLib.FContentText
                                type={'additional2'}
                                text={el.type.join('/')}
                                style={{ color: '#666' }}
                              />

                              {!el.collection && !el.createdCollectionExhibit && (
                                <>
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'|'}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={
                                      // 展出版本
                                      `${FI18n.i18nNext.tAuto('exhibit_entry_exhibitversion')} ${el.version
                                      }`
                                    }
                                    style={{ color: '#666' }}
                                  />
                                </>
                              )}

                              {el.collection && (
                                <>
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'|'}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'资源合集'}
                                    // text={FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_entry_collection')}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'|'}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={
                                      // 0 个单品
                                      FI18n.i18nNext.t(
                                        'nodemgnt_exhibitmgnt_entry_collection_itemcount',
                                        {
                                          itemCount: el.collection.count,
                                        },
                                      )
                                    }
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'|'}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={
                                      el.collection.status === 'finish'
                                        ? // '已完结'
                                        FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')
                                        : // : '连载中'
                                        FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')
                                    }
                                    style={{
                                      color:
                                        el.collection.status === 'finish' ? '#E9A923' : '#42C28C',
                                    }}
                                  />
                                </>
                              )}

                              {el.createdCollectionExhibit && (
                                <>
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'|'}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'展品合集'}
                                    // text={FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_entry_collection')}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={'|'}
                                    style={{ color: '#666' }}
                                  />
                                  <FComponentsLib.FContentText
                                    type={'additional2'}
                                    text={
                                      // 0 个单品
                                      FI18n.i18nNext.t(
                                        'nodemgnt_exhibitmgnt_entry_collection_itemcount',
                                        {
                                          itemCount: el.createdCollectionExhibit.count,
                                        },
                                      )
                                    }
                                    style={{ color: '#666' }}
                                  />
                                </>
                              )}
                            </Space>
                            <div className={styles.polices}>
                              {el.policies.length > 0 ? (
                                <FComponentsLib.F_Contract_And_Policy_Labels
                                  data={el.policies.map((l) => {
                                    return {
                                      text: l,
                                      dot: '',
                                    };
                                  })}
                                  singleRow
                                />
                              ) : (
                                <FComponentsLib.FContentText
                                  text={
                                    // '暂无策略…'
                                    FI18n.i18nNext.t('exhibit_entry_authplan_emtry')
                                  }
                                  type='additional2'
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: 250,
                            flexShrink: -1,
                          }}
                        >
                          <Space
                            size={20}
                            className={[styles.hoverVisible].join(' ')}
                            style={{ width: 60 }}
                          >
                            {!el.collection && !el.createdCollectionExhibit && (
                              <>
                                <FTooltip title={FI18n.i18nNext.tAuto('tip_edit_exhibit')}>
                                  <div>
                                    <FComponentsLib.FTextBtn
                                      type='primary'
                                      onClick={() => {
                                        self.open(
                                          FUtil.LinkTo.exhibitManagement({
                                            exhibitID: el.id,
                                          }),
                                        );
                                      }}
                                    >
                                      <FIcons.FEdit />
                                    </FComponentsLib.FTextBtn>
                                  </div>
                                </FTooltip>

                                <FTooltip title={FI18n.i18nNext.tAuto('tip_check_relevant_resource')}>
                                  <div>
                                    <FComponentsLib.FTextBtn
                                      type='primary'
                                      onClick={() => {
                                        self.open(
                                          FUtil.LinkTo.resourceDetails({
                                            resourceID: el.resourceId,
                                          }),
                                        );
                                      }}
                                    >
                                      <FIcons.FFileSearch />
                                    </FComponentsLib.FTextBtn>
                                  </div>
                                </FTooltip>
                              </>
                            )}

                            {el.collection && (
                              <>
                                <FTooltip title={FI18n.i18nNext.tAuto('tip_edit_exhibit')}>
                                  <div>
                                    <FComponentsLib.FTextBtn
                                      type='primary'
                                      onClick={() => {
                                        self.open(
                                          FUtil.LinkTo.collectionExhibitManagement({
                                            exhibitID: el.id,
                                          }),
                                        );
                                      }}
                                    >
                                      <FIcons.FEdit />
                                    </FComponentsLib.FTextBtn>
                                  </div>
                                </FTooltip>

                                <FTooltip title={FI18n.i18nNext.tAuto('tip_check_relevant_resource')}>
                                  <div>
                                    <FComponentsLib.FTextBtn
                                      type='primary'
                                      onClick={() => {
                                        self.open(
                                          FUtil.LinkTo.collectionDetails({
                                            collectionID: el.resourceId,
                                          }),
                                        );
                                      }}
                                    >
                                      <FIcons.FFileSearch />
                                    </FComponentsLib.FTextBtn>
                                  </div>
                                </FTooltip>
                              </>
                            )}

                            {el.createdCollectionExhibit && (
                              <FTooltip title={FI18n.i18nNext.tAuto('tip_edit_exhibit')}>
                                <div>
                                  <FComponentsLib.FTextBtn
                                    type='primary'
                                    onClick={() => {
                                      self.open(
                                        FUtil.LinkTo.createdCollectionExhibitManagement({
                                          exhibitID: el.id,
                                        }),
                                        // `/node/createdCollectionExhibit/formal/${el.id}`,
                                      );
                                    }}
                                  >
                                    <FIcons.FEdit />
                                  </FComponentsLib.FTextBtn>
                                </div>
                              </FTooltip>
                            )}
                          </Space>
                          <div style={{ width: 50 }} />
                          <Space size={20} style={{ width: 60 }}>
                            {!el.autoUpdate && el.hasUpdateVersion === 'hasUpdate' && (
                              <FTooltip
                                title={
                                  <div>
                                    <FComponentsLib.FContentText
                                      type={'normal'}
                                      // text={'有更新。'}
                                      text={FI18n.i18nNext.t(
                                        'nodemgnt_exhibitmgnt_updatesavailable_msg',
                                      )}
                                    />
                                    <div style={{ height: 10 }} />
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                      }}
                                    >
                                      <FComponentsLib.FTextBtn
                                        type={'primary'}
                                        style={{ fontSize: 12 }}
                                        onClick={async () => {
                                          const { ret, errCode, msg } =
                                            await FServiceAPI.Exhibit.presentablesVersion({
                                              presentableId: el.id,
                                              version: el.resourceLatestVersion,
                                            });
                                          if (ret !== 0 || errCode !== 0) {
                                            fMessage(msg, 'error');
                                            return;
                                          }
                                          await dispatch<ChangeAction>({
                                            type: 'nodeManagerPage/change',
                                            payload: {
                                              exhibit_List: nodeManagerPage.exhibit_List.map(
                                                (e) => {
                                                  if (e.id !== el.id) {
                                                    return e;
                                                  }
                                                  return {
                                                    ...e,
                                                    hasUpdateVersion: 'noUpdate',
                                                    version: e.resourceLatestVersion,
                                                  };
                                                },
                                              ),
                                            },
                                          });
                                        }}
                                      >
                                        {/*更新*/}
                                        {FI18n.i18nNext.tAuto(
                                          'nodemgnt_exhibitmgnt_updatesavailable_btn_update',
                                        )}
                                      </FComponentsLib.FTextBtn>
                                      <FComponentsLib.FTextBtn
                                        type={'primary'}
                                        style={{ fontSize: 12 }}
                                        onClick={() => {
                                          self.open(
                                            el.collection
                                              ? FUtil.LinkTo.collectionDetails({
                                                collectionID: el.resourceId,
                                              })
                                              : FUtil.LinkTo.resourceDetails({
                                                resourceID: el.resourceId,
                                              }),
                                          );
                                        }}
                                      >
                                        {/*查看更新内容*/}
                                        {FI18n.i18nNext.tAuto(
                                          'nodemgnt_exhibitmgnt_updatesavailable_btn_viewdetails',
                                        )}
                                      </FComponentsLib.FTextBtn>
                                      <FComponentsLib.FTextBtn
                                        type={'default'}
                                        style={{
                                          fontSize: 12,
                                          color: '#999',
                                        }}
                                        onClick={async () => {
                                          const { ret, errCode, msg } =
                                            await FServiceAPI.Exhibit.ignorePresentableVersionUpdateTip(
                                              {
                                                presentableId: el.id,
                                                ignoreVersion: el.resourceLatestVersion,
                                              },
                                            );

                                          if (ret !== 0 || errCode !== 0) {
                                            fMessage(msg, 'error');
                                            return;
                                          }

                                          await dispatch<ChangeAction>({
                                            type: 'nodeManagerPage/change',
                                            payload: {
                                              exhibit_List: nodeManagerPage.exhibit_List.map(
                                                (e) => {
                                                  if (e.id !== el.id) {
                                                    return e;
                                                  }
                                                  return {
                                                    ...e,
                                                    hasUpdateVersion: 'ignored',
                                                  };
                                                },
                                              ),
                                            },
                                          });
                                        }}
                                      >
                                        {/*忽略*/}
                                        {FI18n.i18nNext.tAuto(
                                          'nodemgnt_exhibitmgnt_updatesavailable_btn_ingore',
                                        )}
                                      </FComponentsLib.FTextBtn>
                                    </div>
                                  </div>
                                }
                              >
                                <FIcons.FUpdateVersion
                                  style={{
                                    color: '#42C28C',
                                    fontSize: 20,
                                    lineHeight: '20px',
                                    cursor: 'pointer',
                                  }}
                                />
                              </FTooltip>
                            )}

                            {!el.isAuth && (
                              <FTooltip title={el.authErrorText}>
                                <FIcons.FWarning />
                              </FTooltip>
                            )}
                            <div style={{ width: 30 }} />
                          </Space>
                          <div style={{ width: 50 }} />
                          <div>
                            <FSwitch
                              disabled={!el.isAuth && !el.isOnline}
                              checked={el.isOnline}
                              onChange={async (value) => {
                                if (!value) {
                                  const confirm: boolean = await fPromiseModalConfirm({
                                    title: '',
                                    // description: '下架后，其它用户将无法签约该展品，确认要下架吗？',
                                    description: FI18n.i18nNext.t(
                                      'confirm_msg_remove_exhibits_from_auth',
                                    ),
                                    okText: FI18n.i18nNext.t('btn_remove_exhibits_from_auth'),
                                    promptKey_localStorage: 'offlineExhibit',
                                  });
                                  if (!confirm) {
                                    return;
                                  }
                                }

                                dispatch<OnOnlineOrOfflineAction>({
                                  type: 'nodeManagerPage/onOnlineOrOffline',
                                  payload: {
                                    id: el.id,
                                    onlineStatus: value ? 1 : 0,
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {el.collection && (
                        <>
                          <div style={{ height: 15 }} />
                          {el.collection.count > 0 && (
                            <FComponentsLib.FContentText
                              type={'additional2'}
                              // text={`最近更新 ${el.updateData || 'YYYY-MM-DD'}：` + el.collection.items.join(' | ')}
                              text={
                                FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_entry_lastupdated', {
                                  Timestamp: el.collection.latestUpdateTime,
                                }) + el.collection.items.join(' | ')
                              }
                              style={{ color: '#666', maxWidth: '100%' }}
                              singleRow
                            />
                          )}

                          {el.collection.count === 0 && (
                            <FComponentsLib.FContentText
                              type={'additional2'}
                              text={
                                // '未添加单品'
                                FI18n.i18nNext.t('exhibit_entry_collection_empty')
                              }
                              style={{ color: '#666', maxWidth: '100%' }}
                              singleRow
                            />
                          )}
                        </>
                      )}
                      {el.createdCollectionExhibit && (
                        <>
                          <div style={{ height: 15 }} />
                          {el.createdCollectionExhibit.count > 0 && (
                            <FComponentsLib.FContentText
                              type={'additional2'}
                              text={
                                FI18n.i18nNext.tAuto('nodemgnt_exhibitmgnt_entry_lastupdated', {
                                  Timestamp: el.createdCollectionExhibit.latestUpdateTime,
                                }) + el.createdCollectionExhibit.items.join(' | ')
                              }
                              style={{ color: '#666', maxWidth: '100%' }}
                              singleRow
                            />
                          )}

                          {el.createdCollectionExhibit.items.length === 0 && (
                            <FComponentsLib.FContentText
                              type={'additional2'}
                              text={
                                // '未添加单品'
                                FI18n.i18nNext.t('exhibit_entry_collection_empty')
                              }
                              style={{ color: '#666', maxWidth: '100%' }}
                              singleRow
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}

              <FListFooter
                state={nodeManagerPage.exhibit_ListMore}
                onClickLoadMore={() => {
                  dispatch<OnLoadMore_ExhibitList_Action>({
                    type: 'nodeManagerPage/onLoadMore_ExhibitList',
                  });
                }}
              />
            </div>
          </>
        )}
      </div>
      {/* </FLeftSiderLayout> */}

      <ResultModal
        type={nodeManagerPage.updateExhibitResultType}
        dataSource={nodeManagerPage.updateExhibitResult}
        onClose={() => {
          dispatch<ChangeAction>({
            type: 'nodeManagerPage/change',
            payload: {
              updateExhibitResultType: '',
              updateExhibitResult: null,
            },
          });
        }}
      />

      {/* <CreateCollectionModal open={false} onConfirm={() => {}} /> */}
    </>
  );
}

export default connect(({ nodeManagerPage }: ConnectState) => ({
  nodeManagerPage,
}))(Exhibits);

interface ResultModalProps {
  type: '' | 'online' | 'offline' | 'addPolicy';
  dataSource: {
    [k: string]: {
      data: string;
      status: 1 | 2;
    };
  } | null;

  onClose?(): void;
}

function ResultModal({ type, dataSource, onClose }: ResultModalProps) {
  const [$succeedCount, set$succeedCount, get$succeedCount] = FUtil.Hook.useGetState<number>(0);
  const [$failedList, set$failedList, get$failedList] = FUtil.Hook.useGetState<
    {
      cover: string;
      resourceID: string;
      resourceName: string;
      resourceTitle: string;
      resourceType: string;
      failedReason: string;
    }[]
  >([]);

  AHooks.useDebounceEffect(
    () => {
      handledData();
    },
    [dataSource],
    {
      wait: 30,
    },
  );

  async function handledData() {
    if (!dataSource) {
      set$succeedCount(0);
      set$failedList([]);
      return;
    }
    const succeedCount = Object.values(dataSource).filter((d) => {
      return d.status === 1;
    }).length;
    set$succeedCount(succeedCount);
    const failedExhibitIDs: string[] = Object.entries(dataSource)
      .filter((d) => {
        return d[1].status === 2;
      })
      .map((d) => {
        return d[0];
      });
    if (failedExhibitIDs.length > 0) {
      const {
        data,
      }: {
        data: {
          presentableId: string;
          presentableTitle: string;
          presentableName: string;
          coverImages: string[];
          resourceInfo: {
            resourceType: string[];
          };
        }[];
      } = await FServiceAPI.Exhibit.presentableList({
        presentableIds: failedExhibitIDs.join(','),
      });
      // console.log(data, 'data sdifjalskdjflsdjlkfjlksdjlkj');

      set$failedList(
        data.map((d) => {
          return {
            // cover: d.coverImages[0],
            cover: d.coverImages[0] || '',
            resourceID: d.presentableId,
            resourceName: d.presentableName,
            resourceTitle: d.presentableTitle,
            resourceType: d.resourceInfo.resourceType.join('/'),
            failedReason: dataSource[d.presentableId].data,
          };
        }),
      );
    }
  }

  return (
    <Modal
      open={type !== '' && !!dataSource}
      title={null}
      footer={null}
      centered={true}
      width={800}
      styles={{
        body: {
          padding: '50px 60px 40px',
          borderRadius: 10,
        },
      }}
      style={{
        borderRadius: 10,
        overflow: 'hidden',
      }}
      onCancel={() => {
        onClose && onClose();
      }}
    >
      {$succeedCount > 0 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20,
            fontSize: 14,
            fontWeight: 600,
            color: '#42C28C',
          }}
        >
          {type === 'online' && (
            <>
              <FIcons.FUpcast
                style={{
                  fontSize: 76,
                  color: '#42C28C',
                }}
              />
              <div>
                {
                  // 成功上架{$succeedCount}个资源
                  FI18n.i18nNext.tAuto('myresources_bulkaction_msg_availabletoauth_done', {
                    Qty: $succeedCount,
                  })
                }
              </div>
            </>
          )}

          {type === 'offline' && (
            <>
              <FIcons.FUpcast
                style={{
                  fontSize: 76,
                  color: '#42C28C',
                  transform: 'rotate(180deg)',
                }}
              />
              <div>成功下架{$succeedCount}个展品</div>
            </>
          )}

          {type === 'addPolicy' && (
            <>
              <FIcons.FCheck
                style={{
                  fontSize: 76,
                  color: '#42C28C',
                }}
              />
              <div>
                {
                  // 新授权策略已经添加至{$succeedCount}个资源
                  FI18n.i18nNext.tAuto('myresources_bulkaction_msg_addauthplan_done', {
                    Qty: $succeedCount,
                  })
                }
              </div>
            </>
          )}
        </div>
      )}

      {$succeedCount > 0 && $failedList.length > 0 && <div style={{ height: 50 }} />}

      {$failedList.length > 0 && (
        <>
          {type === 'online' && (
            <FComponentsLib.FContentText
              type={'negative'}
              text={
                // 以下资源上架失败：
                FI18n.i18nNext.t('nodemgnt_exhibitmgnt_bulkaction_msg_availabletoauth_failure ')
              }
            />
          )}

          {type === 'offline' && (
            <FComponentsLib.FContentText type={'negative'} text={'以下展品下架失败：'} />
          )}

          {type === 'addPolicy' && (
            <FComponentsLib.FContentText
              type={'negative'}
              text={FI18n.i18nNext.t('nodemgnt_exhibitmgnt_bulkaction_msg_addauthplan_failure ')}
            />
          )}

          <div style={{ height: 20 }} />
          <div style={{ maxHeight: 260, overflowY: 'auto', paddingRight: 10 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap: 5,
              }}
            >
              {$failedList.map((v, i) => {
                return (
                  <>
                    <div
                      key={v.resourceID}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: 68,
                        // borderBottom: '1px solid #E5E7EB',
                        background: 'rgba(0,0,0,0.03)',
                        borderRadius: 10,
                        padding: '0 10px',
                      }}
                    >
                      <Space size={10}>
                        <FCoverImage src={v.cover} width={64} style={{ borderRadius: 4 }} />
                        <div>
                          <FComponentsLib.FContentText
                            type={'highlight'}
                            text={v.resourceTitle || v.resourceName.split('/')[1]}
                            singleRow
                            style={{ maxWidth: 400 }}
                          />
                          <div style={{ height: 10 }} />
                          <FComponentsLib.FContentText
                            type={'additional2'}
                            text={v.resourceType}
                            singleRow
                            style={{ maxWidth: 400 }}
                          />
                        </div>
                      </Space>

                      <FComponentsLib.FContentText
                        type={'additional2'}
                        style={{ color: '#EE4040' }}
                        text={v.failedReason}
                      />
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </>
      )}

      <div style={{ height: 40 }} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <FComponentsLib.FRectBtn
          onClick={() => {
            onClose && onClose();
          }}
        >
          {FI18n.i18nNext.tAuto('myresources_bulkaction_btn_ok')}
        </FComponentsLib.FRectBtn>
      </div>
    </Modal>
  );
}
